import Reveal from "@/components/Reveal";
import { User, UsersThree, MapPin } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

const baseFormats = [
  {
    n: "01",
    icon: User,
    title: "Private sessions",
    text: "One-to-one guidance, fully tailored to your story and your goals — in person or by video, in English or French.",
  },
  {
    n: "02",
    icon: UsersThree,
    title: "Small groups",
    text: "The warmth of shared practice in intimate groups — a gentle way to discover sophrology and mindfulness together.",
  },
  {
    n: "03",
    icon: MapPin,
    title: "Online & in person",
    text: "Based in Katy & Houston, Texas — sessions in person around the area, or online from wherever you are.",
  },
];

export default function Formats() {
  const { t } = useLang();
  const formats = baseFormats.map((f, i) => ({ ...f, ...t.formats.items[i] }));
  return (
    <section id="sessions" className="border-y border-forest/10 bg-peach py-24 lg:py-36" data-testid="sessions-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-6 text-xs font-semibold uppercase tracking-[0.3em] text-stone">{t.formats.eyebrow}</p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl">
            {t.formats.h2a}<em className="italic font-light text-moss">{t.formats.h2b}</em>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {formats.map((f, i) => (
            <Reveal key={f.n} delay={i * 0.12}>
              <div
                className="group flex h-full flex-col rounded-[2rem] border border-forest/10 bg-cream p-10 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_45px_-20px_rgba(44,53,40,0.25)]"
                data-testid={`format-card-${i}`}
              >
                <div className="flex items-center justify-between">
                  <f.icon size={32} weight="duotone" className="text-moss transition-transform duration-500 group-hover:scale-110" />
                  <span className="font-serif text-lg italic text-stone">{f.n}</span>
                </div>
                <h3 className="mt-10 font-serif text-3xl tracking-tight">{f.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-moss md:text-base">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
